let BASE_URL;
let APP_H5_ORIGIN = 'https://vg-app.vgmarkets.com';
let QUOTE_API_URL;
let VG_OSS_URL;
let FIREBASE_CONFIG = {};
let ACCOUNT_TYPE;

const { NODE_ENV } = process.env;

let MOCK_URL = 'http://127.0.0.1:4523/m1/6943915-8608215-default';

switch (ENV) {
  case 'beta':
    BASE_URL = 'https://api-web-beta.wantazz.com';
    APP_H5_ORIGIN = 'https://vg-app-beta.wantazz.com';
    QUOTE_API_URL = 'https://api-quote-beta.wantazz.com';
    VG_OSS_URL = 'https://vg-file-beta-oss.wantazz.com/';
    FIREBASE_CONFIG = {
      apiKey: 'AIzaSyBqXjZrGh2lfAUsnYLS8aUnMguI1IltR0I',
      authDomain: 'vgmarkets-sa-test.firebaseapp.com',
      projectId: 'vgmarkets-sa-test',
      storageBucket: 'vgmarkets-sa-test.firebasestorage.app',
      messagingSenderId: '587409866183',
      appId: '1:587409866183:web:33bb277a8d6563e113ade2',
      measurementId: 'G-3BF1BNTKRG',
    };
    break;
  default:
    BASE_URL = 'https://api-web.vgmarkets.com';
    APP_H5_ORIGIN = 'https://vg-app.vgmarkets.com';
    QUOTE_API_URL = 'https://api-quote.vgmarkets.com';
    VG_OSS_URL = 'https://vg-file-oss.vgmarkets.com/';
    ACCOUNT_TYPE = 40002;
    FIREBASE_CONFIG = {
      apiKey: 'AIzaSyB_VX4_G8WW2wYHwNekyTfVkucfi9ntD3Y',
      authDomain: 'vgmarkets-sa.firebaseapp.com',
      projectId: 'vgmarkets-sa',
      storageBucket: 'vgmarkets-sa.firebasestorage.app',
      messagingSenderId: '57592917529',
      appId: '1:57592917529:web:3e37dfc75770294cf08488',
      measurementId: 'G-6T1ZNTDVVV',
    };
}

const PRODUCT_TYPE = 192;
const WHITE_PAGE_LIST = [
  '/verification/slider-verification',
  '/trading-guide',
  '/user/login',
  'mobile/user/login',
  '/news/news-detail',
  '/about-vg',
  '/agreements/product-disclosure-statement',
  '/agreements/risk-disclosure-statement',
  '/agreements/privacy-policy',
  '/agreements/customer-agreement',
  '/announcement/announcement-detail',
  '/agreements/withdrawal-disclaimer',
  '/activity/claim-reward',
];

if (NODE_ENV === 'development') {
  MOCK_URL = 'http://127.0.0.1:4523/m1/6943915-8608215-default';
}

export default {
  APP_H5_ORIGIN,
  VG_OSS_URL,
  MOCK_URL,
  ACCOUNT_TYPE,
  PRODUCT_TYPE,
  BASE_URL,
  QUOTE_API_URL,
  WHITE_PAGE_LIST,
  FIREBASE_CONFIG,
};
